import { prepareFile, updateFile, uploadDocument } from 'src/modules/documents/api'
import logger from 'src/services/logger'
import { humanReadableSize, mimeTypesIcon } from 'src/utils/file'
import { config } from 'boot/config'
import { empty } from 'src/utils/variable'

const mimeTypeMappings = {
  categories: {
    'image/': 'IMAGE',
    'text/': 'TEXT',
    'video/': 'VIDEO',
    'audio/': 'AUDIO',
    'application/pdf': 'PDF'
  },
  types: {
    'image/': 'Image',
    'video/': 'Vidéo',
    'audio/': 'Audio',
    'application/pdf': 'PDF'
  }
}

export function getStreamUrl(fileId, documentId = '', patientFileId = '') {
  let url = `${config.urls.api}/files/${fileId}/stream`
  const params = new URLSearchParams()

  if (!empty(documentId)) {
    params.append('documentId', documentId)
  }

  if (!empty(patientFileId)) {
    params.append('patientFileId', patientFileId)
  }

  return url + '?' + params.toString()
}

export function getDownloadUrl(fileId, patientFileId, documentId = null) {
  let url = ''

  if (patientFileId) {
    url = `${config.urls.api}/patient_files/${patientFileId}/files/${fileId}/download`
  } else {
    url = `${config.urls.api}/files/${fileId}/download`
  }

  if (!empty(documentId)) {
    url = url + `?documentId=${documentId}`
  }

  return url
}

export function getMimeTypeLabel(mimeType) {
  for (const [prefix, type] of Object.entries(mimeTypeMappings.types)) {
    if (mimeType.startsWith(prefix) || mimeType === prefix) {
      return type
    }
  }
  return 'Non défini'
}

export function getFileType(file) {
  return file?.mimeType ? getMimeTypeLabel(file.mimeType) : null
}

export function getFileSize(file) {
  return file.size ? humanReadableSize(file.size) : null
}

export function getFileMimeTypeCategory(file) {
  const mimeType = file.mimeType
  if (!mimeType) {
    return
  }

  for (const [prefix, category] of Object.entries(mimeTypeMappings.categories)) {
    if (mimeType.startsWith(prefix) || mimeType === prefix) {
      return category
    }
  }
  return 'OTHER'
}

export function getFileIcon(file) {
  const mimeType = file.mimeType
  if (!mimeType) {
    return null
  }

  const mimeTypeParts = mimeType.split('/')
  const mimeTypeCategory = mimeTypeParts[0] || null

  const iconBase = 'fa-file'
  const iconSuffix = mimeTypesIcon[mimeType] || mimeTypesIcon[mimeTypeCategory] || ''

  return iconSuffix ? `${iconBase}-${iconSuffix}` : iconBase
}

/**
 * @param {PrepareFileUploadRequest} data
 * @returns {Promise<*>}
 */
export async function onPrepareFileUploadUrl(data) {
  return (await prepareFile(data)).data.upload_url
}

export async function onEditFileMeta(file) {
  return (await updateFile(file)).data
}

export async function onUploadFile(file) {
  const url = await onPrepareFileUploadUrl(file)
  const formData = new FormData()
  formData.append('file', file)
  try {
    return (await uploadDocument(url, formData)).data
  } catch (e) {
    logger.error(e)
    throw e
  }
}

/**
 * @param {FileList} files
 * @param {PrepareFileUploadRequest} options
 */
export async function onUploadFileFactory(files, options) {
  if (files.length !== 1) {
    // If we sent multiple upload, we will need to use https://quasar.dev/vue-components/uploader#factory-function
    // "The props of this Object can be Functions as well (of form (file[s]) => value):"
    throw new Error('We do not supports multiple uploads')
  }

  return {
    method: 'POST',
    fieldName: 'file',
    withCredentials: true,
    url: await onPrepareFileUploadUrl(options)
  }
}
